import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { Listing, FieldUserMappingAddEdit } from './Pages';

export const FieldUserMappingRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={Listing} />
        <Route exact path={`${match.path}/addEdit`} component={FieldUserMappingAddEdit} />
    </Fragment>
)